<template>
	<div class="head-box d-flex">
		<div class="top-line dis-ib" style="width: 7.125rem;margin-left: 0.3rem;">
			<div class="float-l" style="height: 0.75rem;line-height: 0.75rem;padding-top: 0.15rem;">
				<div class="float-l icon-avatar"></div>
			</div>
			<span class="float-l fw-b ml-2" style="height: 0.75rem;line-height: 0.75rem;">杭州能工科技有限公司</span>
			<div class="float-l ml-5" style="margin-top: 0.125rem" v-if="navbarType">
				<el-select v-model="buildingCom" @change="change" filterable placeholder="请选择">
					<el-option v-for="item in buildingSelect" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="top-line dis-ib mt-2" style="width: 7.9125rem;margin-left: 0.4rem;">
			<span class="fw-b" style="font-size: 0.4rem;">{{ buildingName }}监控平台</span>
			<dv-decoration-5 style="width:100%;height:0.5rem;" />
		</div>
		<div class="top-line dis-ib" style="width: 7.125rem;margin-left: 0.4rem;">
			<div class="float-r">
				<router-link to="/index" :class="selectLi == '/index'?'selectList icon-list float-l':'icon-list float-l'">
					<div v-if="selectLi == '/index'" class="icon icon-zhujiemian"></div>
					<div v-else class="icon icon-zhujiemian1"></div>
					<div class="icon-text">主界面</div>
				</router-link>
				<router-link to="/building" :class="selectLi == '/building'?'selectList icon-list float-l':'icon-list float-l'">
					<div v-if="selectLi == '/building'" class="icon icon-cangku"></div>
					<div v-else class="icon icon-cangku1"></div>
					<div class="icon-text">仓库首页</div>
				</router-link>
				<router-link to="/operation" :class="selectLi == '/operation'?'selectList icon-list float-l':'icon-list float-l'">
					<div v-if="selectLi == '/operation'" class="icon icon-yunxing"></div>
					<div v-else class="icon icon-yunxing1"></div>
					<div class="icon-text">运行管理</div>
				</router-link>
				<router-link to="/energy" :class="selectLi == '/energy'?'selectList icon-list float-l':'icon-list float-l'">
					<div v-if="selectLi == '/energy'" class="icon icon-nenghao"></div>
					<div v-else class="icon icon-nenghao1"></div>
					<div class="icon-text">能耗管理</div>
				</router-link>
				<div @click="child()" class="icon-list float-l">
					<div class="icon icon-tuichu1"></div>
					<div class="icon-text">退出系统</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	export default {
		data() {
			return {
				buildingCom: this.building,
				name: '',
				selectLi: ''
			};
		},
		props: ['buildingSelect', 'navbarType', 'building', 'buildingName'],
		watch: {
			'building': {
				handler() {
					this.change();
				},
			}
		},
		mounted(){
			this.selectLi = this.$route.path=='/'?'/index':this.$route.path
		},
		methods: {
			child() {
				this.$emit('logout')
			},
			change(){
				for(let item of this.buildingSelect){
					if(this.building == item.value){
						this.name = item.label
					}
				}
				let arr = [this.buildingCom, this.name]
				this.$emit('second', arr)
				Cookies.set('buildingName', this.name)
				Cookies.set('building', this.buildingCom)
			}
		}
	};
</script>

<style lang="scss">
	.head-box {
		display: flex;
		// grid-template-columns: 30% 40% 30%;

		.icon-avatar {
			display: inline-block;
			width: 0.48rem;
			height: 0.48rem;
			background: url('~@/assets/avatar.png') no-repeat center;
			background-size: 100%;
		}

		.icon-list {
			margin: 0 auto;
			text-align: center;
			width: 1.06rem;
			height: 0.75rem;
			color: #FFF;
			cursor: pointer;
			opacity: 0.8;

			.icon {
				text-align: center;
				margin: 0 auto;
				display: inline-block;
				width: 0.46rem;
				height: 0.46rem;
			}

			.icon-zhujiemian {
				background: url('~@/assets/icon/zhujiemian.png') no-repeat center;
				background-size: cover; 
			}
			.icon-cangku {
				background: url('~@/assets/icon/cangku.png') no-repeat center;
				background-size: cover; 
			}
			.icon-yunxing {
				background: url('~@/assets/icon/yunxing.png') no-repeat center;
				background-size: cover; 
			}
			.icon-nenghao {
				background: url('~@/assets/icon/nenghao.png') no-repeat center;
				background-size: cover; 
			}
			.icon-tuichu {
				background: url('~@/assets/icon/tuichu.png') no-repeat center;
				background-size: cover; 
			}
			
			.icon-zhujiemian1 {
				background: url('~@/assets/icon/zhujiemian1.png') no-repeat center;
				background-size: cover; 
			}
			.icon-cangku1 {
				background: url('~@/assets/icon/cangku1.png') no-repeat center;
				background-size: cover; 
			}
			.icon-yunxing1 {
				background: url('~@/assets/icon/yunxing1.png') no-repeat center;
				background-size: cover; 
			}
			.icon-nenghao1 {
				background: url('~@/assets/icon/nenghao1.png') no-repeat center;
				background-size: cover; 
			}
			.icon-tuichu1 {
				background: url('~@/assets/icon/tuichu1.png') no-repeat center;
				background-size: cover; 
			}
		}

		.top-line {
			text-align: center;

			span {
				color: #FFF;
				font-size: 0.3125rem;
				transform: skewX(-10deg);
			}
			div{
				.selectList{
					opacity: 1;
					color: #47E4E5;
				}
				.el-input__inner {
					background: none;
					border: 0;
					color: #fff;
				
					.el-range-input {
						background: none;
						color: #fff;
					}
				
					.el-range-separator {
						color: #fff;
					}
				}
				.icon-text{
					font-size: 0.18rem;
				}
			}
		}
	}
</style>
